module.exports = __webpack_public_path__ + "static/media/venetian02.a19ecc45.png";